import { ColorType, ColorsDark, ColorsLight, PaletteMode } from '../../theme';
import { ChipColor } from '../types';

export const TEXT_COLORS: Record<ChipColor, Record<PaletteMode, ColorType>> = {
  blue50: {
    light: ColorsLight.blue250,
    dark: ColorsDark.blue250,
  },
  blue100: {
    light: ColorsLight.blue250,
    dark: ColorsDark.blue250,
  },
  red: {
    light: ColorsLight.red200,
    dark: ColorsDark.red200,
  },
  yellow: {
    light: ColorsLight.yellow100,
    dark: ColorsDark.yellow100,
  },
  green: {
    light: ColorsLight.green100,
    dark: ColorsDark.green100,
  },
  purple50: {
    light: ColorsLight.purple100,
    dark: ColorsDark.purple100,
  },
  purple150: {
    light: ColorsLight.purple200,
    dark: ColorsDark.purple200,
  },
};

export const BG_COLORS: Record<ChipColor, Record<PaletteMode, ColorType>> = {
  blue50: {
    light: ColorsLight.blue50,
    dark: ColorsDark.blue50,
  },
  blue100: {
    light: ColorsLight.blue100,
    dark: ColorsDark.blue100,
  },
  red: {
    light: ColorsLight.red50,
    dark: ColorsDark.red50,
  },
  yellow: {
    light: ColorsLight.yellow50,
    dark: ColorsDark.yellow50,
  },
  green: {
    light: ColorsLight.green50,
    dark: ColorsDark.green50,
  },
  purple50: {
    light: ColorsLight.purple50,
    dark: ColorsDark.purple50,
  },
  purple150: {
    light: ColorsLight.purple150,
    dark: ColorsDark.purple150,
  },
};
